// src/pages/Checkout.jsx
import React, { useState } from "react";
import styled from "styled-components";
import { useAuth } from "../contexts/AuthContext"; // adjust if needed

export default function Checkout() {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCheckout = async () => {
    try {
      setLoading(true);
      setError("");

      if (!currentUser) {
        throw new window.Error("You must be logged in to checkout.");
      }

      const idToken = await currentUser.getIdToken();

      const res = await fetch(
        "https://us-central1-asites-planner.cloudfunctions.net/createStripeCheckoutSession",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify({}),
        }
      );

      const raw = await res.text();
      let data = null;
      try {
        data = raw ? JSON.parse(raw) : null;
      } catch {
        data = null;
      }

      if (!res.ok) {
        const messageFromJson =
          data?.details ||
          data?.error ||
          (data?.upstreamStatus
            ? `Upstream error (${data.upstreamStatus})`
            : null);
        const message = messageFromJson || raw || `Request failed (${res.status})`;
        throw new window.Error(message);
      }

      if (data?.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      }
    } catch (err) {
      console.error("Checkout Error:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Card>
        <Title>Upgrade to Pro</Title>
        <Price>
          $19<span>/month</span>
        </Price>

        <Features>
          <li>Unlimited projects</li>
          <li>Advanced productivity tools</li>
          <li>Cloud sync</li>
          <li>Priority updates</li>
        </Features>

        {error && <Error>{error}</Error>}

        <Button onClick={handleCheckout} disabled={loading}>
          {loading ? "Redirecting..." : "Subscribe Now"}
        </Button>

        <SmallText>Secure payment • Cancel anytime</SmallText>
      </Card>
    </Container>
  );
}
const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at top, #6b5cff33, transparent);
`;

const Card = styled.div`
  width: 420px;
  background: #0f0f13;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  color: white;
`;

const Title = styled.h1`
  font-size: 26px;
  margin-bottom: 8px;
`;

const Price = styled.div`
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 20px;

  span {
    font-size: 16px;
    opacity: 0.6;
    margin-left: 6px;
  }
`;

const Features = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 24px;

  li {
    margin-bottom: 10px;
    opacity: 0.9;
  }
`;

const Button = styled.button`
  width: 100%;
  height: 52px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #6b5cff, #8f7bff);
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Error = styled.div`
  color: #ff6b6b;
  margin-bottom: 12px;
`;

const SmallText = styled.p`
  margin-top: 14px;
  font-size: 13px;
  opacity: 0.6;
  text-align: center;
`;
